/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: PanControls.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/4 @ 1517
 * ---
 * Description:
 */


import {
  Button,
  ButtonGroup,
  NavbarGroup,
  PopoverPosition
}                   from '@blueprintjs/core';
import { Tooltip2 } from '@blueprintjs/popover2';
import { observer } from 'mobx-react';
import { Editor }   from '../../../store/observables/Editor';

interface Props {
  editor: Editor;
}

export const PanControls = observer((props: Props) => {
  const panFeature = props.editor.pan();

  return (
    <NavbarGroup>
      <ButtonGroup>
        <Tooltip2 content={ 'Ripristina vista' }
                  position={ PopoverPosition.BOTTOM }>
          <Button small icon={ 'zoom-to-fit' }
                  onClick={ () => panFeature.reset() }/>
        </Tooltip2>
        <Tooltip2 content={ 'Sposta vista a sinistra' }>
          <Button small icon={ 'arrow-left' }
                  onClick={ () => panFeature.moveViewLeft() }/>
        </Tooltip2>
        <Tooltip2 content={ 'Sposta vista a destra' }
                  position={ PopoverPosition.BOTTOM }>
          <Button small icon={ 'arrow-right' }
                  onClick={ () => panFeature.moveViewRight() }/>
        </Tooltip2>
        <Tooltip2 content={ 'Sposta vista in su' }
                  position={ PopoverPosition.BOTTOM }>
          <Button small icon={ 'arrow-up' }
                  onClick={ () => panFeature.moveViewUp() }/>
        </Tooltip2>
        <Tooltip2 content={ 'Sposta vista in giu' }
                  position={ PopoverPosition.BOTTOM }>
          <Button small icon={ 'arrow-down' }
                  onClick={ () => panFeature.moveViewDown() }/>
        </Tooltip2>
      </ButtonGroup>
    </NavbarGroup>
  );
});
